export default "__VITE_ASSET__djrt72HQ__"